import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { AppUtils } from "@app/shared/util/app.utils";
import { PagedResponse } from "@models/response.model";
import { Reason, ReasonScope } from "@models/reason.model";
import { map } from "rxjs/operators";

@Injectable()
export class ReasonsService {
    static readonly REASONS_API_GET_PATH = `${environment.baseURL}/api/reasons`;

    constructor(private http: HttpClient) {
    }

    getAllIReasons(tableConfig: TableConfig = null, scope: ReasonScope = null) {
        let params = AppUtils.buildPageableParams(tableConfig);
        if (scope !== null) {
            params = params.set('scope', `${scope}`);
        }
        return this.http.get<PagedResponse<Reason>>(ReasonsService.REASONS_API_GET_PATH, {params: params})
        .pipe(map(this.mapReasons));
    }

    createReason(reason) {
        return this.http.post<Reason>(`${ReasonsService.REASONS_API_GET_PATH}`, reason);
    }

    updateReason(reason) {
        return this.http.put<Reason>(`${ReasonsService.REASONS_API_GET_PATH}/${reason.id}`, reason);
    }

    deleteReason(reason) {
        return this.http.delete<Reason>(`${ReasonsService.REASONS_API_GET_PATH}/${reason.id}`);
    }


    mapReasons = res => {
        return {
            items: res.items.map(item => new Reason(item)),
            count: res.total
        };
    };
}
